import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { billGridClass } from '@/features/dashboard/bookingChanges/components/primitives';

interface BillSectionSkeletonProps
  extends React.HTMLAttributes<HTMLDivElement> {
  rowCount?: number;
}

/**
 * Szkielet zwijanej sekcji — trzyma tę samą siatkę kolumn co `BillSection`,
 * żeby po wczytaniu danych nic nie przeskoczyło.
 */
const BillSectionSkeleton = ({
  rowCount = 3,
  className,
  ...props
}: BillSectionSkeletonProps) => (
  <div
    className={cn(
      'overflow-hidden rounded-xl border border-neutral-200 bg-basic-white',
      className,
    )}
    {...props}
  >
    <div className="flex items-center gap-2.5 border-b border-neutral-100 bg-neutral-50 px-[18px] py-[13px]">
      <Skeleton className="size-3.5 rounded-full" />
      <Skeleton className="h-3 w-32" />
      <Skeleton className="ml-auto h-3 w-20" />
    </div>

    <div className={cn(billGridClass, 'items-center px-[18px]')}>
      {Array.from({ length: rowCount }, (_, index) => (
        <div key={index} className="contents">
          <div className="py-[13px]">
            <Skeleton className="h-3.5 w-28" />
          </div>
          <div className="py-[13px]">
            <Skeleton className="h-3.5 w-48" />
          </div>
          <div className="flex justify-end py-[13px]">
            <Skeleton className="h-3.5 w-20" />
          </div>
          <div className="flex justify-end py-[13px]">
            <Skeleton className="h-7 w-24 rounded-[7px]" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default BillSectionSkeleton;
